<div class="t-popup popup-patientDetails" *ngIf="ce.ErrorType!=''" style='display: block'>

    <div class="t-popup-close"></div>
    
    <div class="t-popup-frame error-w">
        <div class="t-popup-body">

            <button class="t-btn-popup-close" aria-label="close popup" (click)="close()"></button>

            <h2 style='color: #D7A95B;text-align: center;' [ngClass]="ce.isCardio ? 'crdio-err' : ''">
                {{ce.ErrorType}} {{ce.calendarForm || ce.sessionExpiration ? '' : 'Error'}}
            </h2>
            <!-- box (end) -->

            <div style="display: flex; justify-content: center;" class="l-flex l-flex-w t-fieldmargin patient-details">
                {{ce.Error}}
                <button class="save_patieont" (click)="login()" *ngIf="ce.ErrorType === 'Session'">
					Login
				</button>
                <button class="save_patieont" (click)="refreshSession()" *ngIf="ce.ErrorType === 'Session About To Expire'">
                    Stay Connected
                </button>
                <button class="save_patieont" (click)="login(true)" *ngIf="ce.logError">
					Back To Login
				</button>
                <button class="save_patieont" (click)="cardioErr()" *ngIf="ce.isCardio">
					המשך
				</button>
            </div>
            <div *ngIf="ce.calendarForm" style="display:flex;">
                <button class="save_patieont" style="min-width:7.9em;" (click)="close(true)">
                    שמור
                </button>
                <button class="delete_patieont" style="min-width:7.9em;" (click)="close(false)">
                    בטל
                </button>
            </div>

            

        </div>
    </div>

</div>
